<template>
  <aside
    class="right-panel"
    :data-figma-node="variant.figmaNodeId"
    :data-panel-variant="variant.name"
  >
    <NewStudioRightPanelSections :variant="variant" />
  </aside>
</template>

<script setup lang="ts">
import { resolvePanelVariant } from './variantMap'

const gridStore = useGridStore()
const variant = computed(() => resolvePanelVariant(gridStore.gridPattern?.id))
</script>

<style scoped>
.right-panel { box-sizing: border-box; width: 340px; height: 100%; min-height: 825px; padding: 8px 40px 24px 20px; overflow-x: hidden; overflow-y: auto; border-left: 1px solid #e7e6e1; background: #fff; }
</style>
